import { COMPETENCIES_ROUTES } from '../../constants/_routes'
import competenciesTypes from '../../constants/competenciesTypes'
import { axios } from '../../services'

// INDEX
const competencies_index_request = () => {
  return {
    type: competenciesTypes.index.request
  }
}

const competencies_index_success = (response) => {
  return {
    type: competenciesTypes.index.success,
    payload: response.data
  }
}

const competencies_index_failure = (messages) => {
  return {
    type: competenciesTypes.index.failure,
    payload: messages
  }
}

const competencies_index = () => {
  return function (dispatch) {
    // Before Request
    dispatch(competencies_index_request())

    // Request
    axios.get(
      COMPETENCIES_ROUTES.index
    ).then( response => {
      // success
      dispatch( competencies_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching competencies."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( competencies_index_failure(errors))
    })
  }

}

export {
  competencies_index
}



// WEBPACK FOOTER //
// ./src/js/actions/competencies/getindex.js